import React, { useEffect, FC } from 'react';

import { Outlet, useLocation } from 'react-router-dom';

import ErrorBoundary from '@nhl/nhl-react-ui/lib/ErrorBoundary';

import Footer from '../../components/footer';
import HeaderMenu from '../../components/headerMenu';
import MetaHelmet from '../../components/metaHelmet/MetaHelmet';

export const getDataLayer = () => {
    window.dataLayer = window.dataLayer || [];
    return window.dataLayer;
};

const App: FC = () => {
    const location = useLocation();

    const sendGoogleAnalyticsPageView = () => {
        getDataLayer().push({
            event: 'page_view',
            page_path: location.pathname,
        });
    };

    useEffect(() => {
        window.scrollTo(0, 0);
        sendGoogleAnalyticsPageView();
    }, [location.pathname]);

    return (
        <div id="wrapper">
            <header>
                <HeaderMenu />
            </header>
            <div id="mainSection" className="main-section">
                <main className="content">
                    <ErrorBoundary>
                        <MetaHelmet />
                        <Outlet />
                    </ErrorBoundary>
                </main>
            </div>
            <Footer />
        </div>
    );
};

export default App;
